import * as React from "react";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import { Col } from "common/components";
import { useFetchEventProcedures } from "security-app/hooks/useEventProceduresAPI";
import { listElements } from "./constants";
import { columnRenderers } from "./column-renderers";
import useTableElements from "./use-table-elements";
function EventProceduresLibraryList() {
  const { searchEventProcedures, eventProceduresEntitiesKeyFn } = useFetchEventProcedures();
  const { expandedSections } = useTableElements();
  return /* @__PURE__ */ React.createElement(Col, { $align: "center" }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "Event Procedures",
      tableLayout: listElements.defaultLayout,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "Event Procedure" }),
      fetchEntities: searchEventProcedures,
      keyFn: eventProceduresEntitiesKeyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      expandedSectionRenderers: expandedSections,
      withoutURLParams: true
    }
  ));
}
export default EventProceduresLibraryList;
